import { render, staticRenderFns } from "./width.vue?vue&type=template&id=072a4393&scoped=true&"
import script from "./width.vue?vue&type=script&lang=js&"
export * from "./width.vue?vue&type=script&lang=js&"
import style0 from "./width.vue?vue&type=style&index=0&id=072a4393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a4393",
  null
  
)

export default component.exports